"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CaretDown_svg_1 = require("../../assets/icons/CaretDown.svg");
var Button_1 = require("../Button");
var constants_1 = require("./constants");
var DropdownBase_st_css_1 = require("./DropdownBase.st.css");
exports.DropdownBase = function (props) {
    var selectedOption = props.selectedOption, placeholder = props.placeholder, error = props.error, disabled = props.disabled, upgrade = props.upgrade, ariaLabel = props["aria-label"], ariaLabelledBy = props["aria-labelledby"], rtl = props.rtl;
    var hasPlaceholder = !selectedOption || !selectedOption.value;
    return (React.createElement(Button_1.Button, __assign({ upgrade: upgrade, fullWidth: true }, DropdownBase_st_css_1.default('root', { error: error, placeholder: hasPlaceholder, upgrade: upgrade, rtl: rtl }, props), { "data-hook": constants_1.DATA_HOOKS.base, "data-dropdown-base-error": error, disabled: disabled, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-haspopup": true, prefixIcon: selectedOption && selectedOption.icon ? (React.createElement("div", { className: DropdownBase_st_css_1.default.optionIcon }, selectedOption.icon)) : null, suffixIcon: React.createElement(CaretDown_svg_1.ReactComponent, { className: DropdownBase_st_css_1.default.arrowIcon, width: constants_1.ICON_SIZE, height: constants_1.ICON_SIZE }) }),
        React.createElement("div", { className: DropdownBase_st_css_1.default.childrenWrapper, "data-hook": constants_1.DATA_HOOKS.baseText }, (selectedOption && selectedOption.value) || placeholder)));
};
//# sourceMappingURL=DropdownBase.js.map